import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{staticClass:"breadcrumb-sub-list"},[_vm._l((_vm.value),function(item,i){return [(item)?_c(VListItem,{key:item.id,on:{"!click":function($event){$event.stopPropagation();return _vm.$emit('click', item)}}},[_c(VListItemIcon,[(item.icon)?_c(VIcon,{attrs:{"left":"","color":"primary"}},[_vm._v(" "+_vm._s(item.icon)+" ")]):_vm._e()],1),_c(VListItemTitle,[_c('span',{staticClass:"text-truncate truncated-title"},[_vm._v(_vm._s(item.title))])])],1):_vm._e(),(!item)?_c(VDivider,{key:'divider_' + i}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }